import { CMHeadingContainer } from './heading.styles';

const Heading = ({previusPage, currentPage} ) => {
    return (
        <CMHeadingContainer>
            <nav>
                <a className='current'>{previusPage} {currentPage ? '/' : ''}</a>
                {currentPage ? <a>&nbsp;{currentPage}</a> : ''}
            </nav>
        </CMHeadingContainer>
    )
}

export default Heading;